import * as React from 'react';
import type { Options } from './types/public/options';
import type { StartType } from './types/public/models';

const boomi: typeof window.boomi = {
    flow: {
        React,
        // Read by the debugger in the Designtime to determine if an unload was a redirect or a close
        isRedirecting: false,
    },
};

window.boomi = boomi;

/**
 * Expose React so it can be accessed by custom components
 */
declare global {
    interface Window {
        boomi: {
            flow: {
                React: typeof React;
                isRedirecting: boolean;
            };
        };
        /** @internal */
        _internal_onbeforeflowstart: ((options: Options) => Options | Promise<Options>) | undefined;
        onbeforeflowstart:
            | ((
                  options: Options,
                  /**
                   * @deprecated
                   */
                  startType: StartType,
              ) => Options | Promise<Options>)
            | undefined;
    }
}
